// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchInput_searchBox__VOVDH","searchIcon":"SearchInput_searchIcon__8iWM0","searchInput":"SearchInput_searchInput__XAYLS","clearButton":"SearchInput_clearButton__326hH"};